import classNames from 'classnames';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { DealersDTO } from '../../../common/types/dto/DealersDTO';
import { LookupValueDTO } from '../../../common/types/dto/LookupValueDTO';
import { RootState } from '../../base/RootReducer';

interface DealerDistrictSelectState {
    districts: Array<LookupValueDTO<string>>;
    dealers: Array<LookupValueDTO<string>>;
    staticDealer: DealersDTO | undefined;
    districtSelected: any;
}

export interface DealerDistrictSelectProps {
    onChange: (selected: any) => void;
    staticDealerCode?: number;
    validation: boolean;
    disbaleSelectorOnSubmit: boolean;
    sideBySideSelectorsDisplay: boolean;
    divClassName?: string | null;
    labelClassName?: string | null;
    selectClassName?: string | null;
}

interface ReduxStateProps {
    dealers: DealersDTO[] | undefined;
    districts: string[] | undefined;
}

type DealerDistrictSelectProperties =
    ReduxStateProps
    & DealerDistrictSelectProps;

const DealerDistrictSelect: React.FC<DealerDistrictSelectProperties> = (Props) => {
    const { t } = useTranslation();
    const initialState: DealerDistrictSelectState = {
        districts: [],
        dealers: [],
        staticDealer: undefined,
        districtSelected: undefined,
    };
    const [state, setState]: [DealerDistrictSelectState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );

    useEffect(() => {
        if (Props.districts) {
            const districts: Array<LookupValueDTO<string>> = [];
            Props.districts.map((dist) => {
                districts.push({
                    label: dist,
                    value: dist,
                });
            });
            setState({ districts });
        }
    }, [Props.dealers, Props.districts]);

    useEffect(() => {
        if (Props.staticDealerCode && Props.dealers) {
            const staticDealer = Props.dealers.find((x) => x.value === Props.staticDealerCode);
            setState({ staticDealer });
        } else if (state.staticDealer) {
            setState({ staticDealer: undefined });
        }
    }, [Props.staticDealerCode]);

    function onDistrictChange(selected: any) {
        if (Props.dealers && selected) {
            const dealers: Array<LookupValueDTO<number>> = [];
            Props.dealers.map((dealerItem) => {
                if (dealerItem.district === selected.value) {
                    dealers.push({
                        label: dealerItem.label,
                        value: dealerItem.value,
                    });
                }
            });
            dealers.unshift({
                label: `- ${t('dealerDistrictSelect.select')} ${t('dealerDistrictSelect.dealer')} -`,
                value: 0,
            });
            setState({
                dealers,
                districtSelected: selected,
            });
            Props.onChange(null);
        }
    }

    function onDealerChange(x: React.ChangeEvent<HTMLSelectElement>) {
        if (parseInt(x.target.value, 10) <= 0) {
            Props.onChange(null);
        } else {
            Props.onChange(x.target);
        }
    }

    const SelDealer: React.FC = () => {
        return (
            <div className={'selectwrapper'}>
                <select name="concessionario" onChange={onDealerChange} className={classNames(['form-control', 'base-select', Props.selectClassName])}>
                    {state.dealers.map((x, id) => {
                        return <option key={'opc' + id} value={x.value}>{x.label}</option>;
                    })}
                </select>
            </div>
        );
    };

    const SelDealerMemo = React.useMemo(
        () => SelDealer,
        [state.dealers, state.districtSelected],
    );

    if (Props.validation) {
        return (
            <React.Fragment>
                <div className={Props.divClassName ? Props.divClassName : classNames(['cell', Props.sideBySideSelectorsDisplay ? 'large-6' : 'large-12', 'text-left'])}>
                    <label htmlFor="distrito" className={classNames(['form-label', 'distritosReparadores', Props.labelClassName])}>{t('dealerDistrictSelect.district')}*
                        {
                            state.staticDealer && Props.disbaleSelectorOnSubmit ?
                                <div className={'form-label-value'}>{state.staticDealer.district}</div> :
                                <div className={'selectwrapper'}>
                                    <select name="distrito" onChange={(x) => onDistrictChange(x.target)} className={classNames(['form-control', 'base-select', Props.selectClassName])}>
                                        <option value="">- {t('dealerDistrictSelect.select') + ' ' + t('dealerDistrictSelect.district')} -</option>
                                        {state.districts.map((x, id) => {
                                            return <option key={'opd' + id} value={x.value}>{x.label}</option>;
                                        })}
                                    </select>
                                </div>
                        }
                    </label>
                </div>

                <div className={Props.divClassName ? Props.divClassName : classNames(['cell', Props.sideBySideSelectorsDisplay ? 'large-6' : 'large-12', 'text-left'])}>
                    <label htmlFor="concessionario" className={classNames(['form-label', 'reparadores', Props.labelClassName])}>{t('dealerDistrictSelect.dealer')}*
                        {
                            state.staticDealer && Props.disbaleSelectorOnSubmit ?
                                <div className={'form-label-value'}>{state.staticDealer.label}</div> :
                                <SelDealerMemo />
                        }
                    </label>
                </div>
            </React.Fragment>
        );
    }
    return null;
};

const mapStateToProps = (store: RootState) => ({
    dealers: store.appState.lookupValues.dealers,
    districts: store.appState.lookupValues.districts,
});

export default connect(mapStateToProps)(DealerDistrictSelect);
